// Importing components
import DesignationManagement from "./scenes/designation";
import EmployeeManagement from "./scenes/employees";
import HolidayManagement from "./scenes/holiday";
import SettingManagement from "./scenes/setting";
import ShiftManagement from "./scenes/shift";
import TeamManagement from "./scenes/team";
import WFHManagement from "./scenes/wfh";
import AttendanceManagement from "./scenes/attendance";
import AnalyticsManagement from "./scenes/analytics";
import RoleManagement from "./scenes/role";
import ProfileManagement from './scenes/profile';
import SearchManagement from "./scenes/search";
import MailManagement from "./scenes/mail";
import RequestLeaveViewManagement from "./scenes/requestleave";

// Importing components label
import {
    DESIGNATION_MANAGEMENT,
    TEAM_MANAGEMENT,
    SHIFT_MANAGEMENT,
    WFH_MANAGEMENT,
    ATTENDANCE_MANAGEMENT,
    ANALYTICS_MANAGEMENT,
    ROLE_MANAGEMENT,
    HOLIDAY_MANAGEMENT,
    EMPLOYEE_MANAGEMENT,
    PROFILE_MANAGEMENT,
    SETTING_MANAGEMENT,
    SEARCH_MANAGEMENT,
    MAIL_MANAGEMENT,
    REQUEST_LEAVE_MANAGEMENT
} from './constants';

// Allowed Routes
const allowedRoutes = {
    [EMPLOYEE_MANAGEMENT]: {
        "route": "/employees/:teamId?",
        "component": EmployeeManagement,
        "icon": "bi-people",
        "component_label": "Employees",
        "active_sidebar": true,
        // "props": {
        //     query: "?q&_ehphide",
        // },
    },
    [DESIGNATION_MANAGEMENT]: {
        "route": "/designations",
        "component": DesignationManagement,
        "icon": "bi-person-badge",
        "component_label": "Designations",
        "active_sidebar": true,
    },
    [TEAM_MANAGEMENT]: {
        "route": "/teams",
        "component": TeamManagement,
        "icon": "bi-microsoft-teams",
        "component_label": "Teams",
        "active_sidebar": true,
    },
    [SHIFT_MANAGEMENT]: {
        "route": "/shifts",
        "component": ShiftManagement,
        "icon": "bi-clock-history",
        "component_label": "Shifts",
        "active_sidebar": true,
    },
    [WFH_MANAGEMENT]: {
        "route": "/wfh",
        "component": WFHManagement,
        "icon": "bi-person-video3",
        "component_label": "WFH",
        "active_sidebar": true,
    },
    [HOLIDAY_MANAGEMENT]: {
        "route": "/holidays",
        "component": HolidayManagement,
        "icon": "bi-airplane",
        "component_label": "Holidays",
        "active_sidebar": true,
    },
    [REQUEST_LEAVE_MANAGEMENT]: {
        "route": "/request-leaves",
        "component": RequestLeaveViewManagement,
        "icon": "bi-card-checklist",
        "component_label": "Request Leave",
        "active_sidebar": true,
    },
    [ATTENDANCE_MANAGEMENT]: {
        "route": "/attendances/:employeeId?",
        "component": AttendanceManagement,
        "icon": "bi-clipboard-data",
        "component_label": "Attendances",
        "active_sidebar": true,
    },
    [ANALYTICS_MANAGEMENT]: {
        "route": "/analytics",
        "component": AnalyticsManagement,
        "icon": "bi-file-bar-graph",
        "component_label": "Analytics",
        "active_sidebar": true,
    },
    [MAIL_MANAGEMENT]: {
        "route": "/mails",
        "component": MailManagement,
        "icon": "bi-envelope",
        "component_label": "Mails",
        "active_sidebar": true,
    },
    [ROLE_MANAGEMENT]: {
        "route": "/roles",
        "component": RoleManagement,
        "icon": "bi-key-fill",
        "component_label": "Roles",
        "active_sidebar": true,
    },
    [SETTING_MANAGEMENT]: {
        "route": "/settings",
        "component": SettingManagement,
        "icon": "bi-gear",
        "component_label": "Settings",
        "active_sidebar": true,
    },
    [PROFILE_MANAGEMENT]: {
        "route": "/profile",
        "component": ProfileManagement,
        "icon": "bi-person",
        "component_label": "Profile",
        "active_sidebar": false,
    },
    [SEARCH_MANAGEMENT]: {
        "route": "/search",
        "component": SearchManagement,
        "icon": "bi-search",
        "component_label": "Search",
        "active_sidebar": false,
        "props": {
            query: "s",
        },
    }
};

export default allowedRoutes;